<template>
  <v-dialog
    :value="value"
    persistent
    max-width="50rem">
    <v-card>
      <v-card-text>
        <v-container>
          <v-form v-model="valid">
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="editedSubcontractor.name"
                  :rules="[v => !!v || 'Name is equired']"
                  label="Name"/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-autocomplete
                  v-model="editedSubcontractor.states"
                  :filter="statesFilter"
                  :items="states"
                  chips
                  item-text="name"
                  item-value="id"
                  label="Covered states"
                  placeholder="Add a state..."
                  multiple/>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="posting"
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          :disabled="posting || !valid"
          flat
          @click="save">
          <v-progress-circular
            v-if="posting"
            indeterminate/>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "edit-dialog",
  props: {
    subcontractor: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      editedSubcontractor: {},
      loading: false,
      posting: false,
      states: [],
      valid: false
    };
  },
  watch: {
    value (newVal) {
      if (newVal === true) {
        Object.assign(
          this.editedSubcontractor,
          { name: this.subcontractor.name },
          { states: this.subcontractor.states.map((st) => st.id) }
        );
      }
    }
  },
  created () {
    // Get all the states available for autocompletion
    this.loading = true;
    this.$http.get("/api/states").
      then((r) => this.states = Array.from(r.data)).
      finally(() => this.loading = false);
  },
  methods: {
    // When the SAVE button of the edition dialog is clicked
    save () {
      this.posting = true;
      this.$http.
        put(`/api/subcontractors/${this.subcontractor.id}`, {
          name: this.editedSubcontractor.name,
          states: Array.from(this.editedSubcontractor.states)
        }).then(() => {
          this.$emit("refresh");
          this.$emit("input", false);
        }).
        finally(() => this.posting = false);
    },
    // Autocomplete: states
    statesFilter (item, query) {
      let q = query ? query : "";
      let h = item.name ? item.name : "";
      return h.toLowerCase().indexOf(q.toLowerCase()) > -1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subcontractor/EditDialog.vue